import * as React from 'react';
import { TypographyProps } from '../typography-props';
import { BaSeTypographyWrapper } from '../typography-wrapper';
import { StyledText } from './text-styled';

export const BaSeText: React.FC<TypographyProps> = (props) => (
  <BaSeTypographyWrapper
    fontSize={1}
    lineHeight={1.46}
    wrapper={StyledText}
    {...props}
  >
    {props.children}
  </BaSeTypographyWrapper>
);

BaSeText.displayName = 'BaSeText';
